(function (window, document) {
  if (window.MVRfqAttribution) return;

  var storageKey = 'mv_rfq_attribution_v1';
  var script = document.currentScript;
  var pageType = script && script.dataset ? script.dataset.pageType || '' : '';

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeSession(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {}
  }

  function clean(value, max) {
    return String(value || '').trim().slice(0, max || 1200);
  }

  function queryValue(params, name) {
    return clean(params.get(name), 500);
  }

  function firstTouch() {
    var saved = readSession(storageKey);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (error) {}
    }

    var params = new URLSearchParams(window.location.search);
    var record = {
      initial_landing_url: clean(window.location.href),
      initial_landing_path: clean(window.location.pathname + window.location.search),
      initial_referrer: clean(document.referrer),
      utm_source: queryValue(params, 'utm_source'),
      utm_medium: queryValue(params, 'utm_medium'),
      utm_campaign: queryValue(params, 'utm_campaign'),
      utm_term: queryValue(params, 'utm_term'),
      utm_content: queryValue(params, 'utm_content'),
      gclid: queryValue(params, 'gclid'),
      fbclid: queryValue(params, 'fbclid'),
      msclkid: queryValue(params, 'msclkid'),
      captured_at: new Date().toISOString()
    };
    writeSession(storageKey, JSON.stringify(record));
    return record;
  }

  function sessionId() {
    return clean(readSession('mv_sid'), 160) || null;
  }

  function context(extra) {
    var record = firstTouch();
    var result = {
      visitor_session_id: sessionId() || '',
      initial_landing_url: record.initial_landing_url || '',
      initial_landing_path: record.initial_landing_path || '',
      initial_referrer: record.initial_referrer || '',
      current_page_url: clean(window.location.href),
      current_page_path: clean(window.location.pathname + window.location.search),
      current_page_title: clean(document.title, 500),
      page_type: clean(pageType, 120),
      utm_source: record.utm_source || '',
      utm_medium: record.utm_medium || '',
      utm_campaign: record.utm_campaign || '',
      utm_term: record.utm_term || '',
      utm_content: record.utm_content || '',
      gclid: record.gclid || '',
      fbclid: record.fbclid || '',
      msclkid: record.msclkid || '',
      captured_at: new Date().toISOString()
    };
    Object.keys(extra || {}).forEach(function (key) {
      result[key] = clean(extra[key], 1200);
    });
    return result;
  }

  function track(name, fields) {
    var payload = {};
    Object.keys(fields || {}).forEach(function (key) {
      var value = fields[key];
      if (value !== undefined && value !== null && value !== '') payload[key] = clean(value, 500);
    });
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
  }

  var publishedQuotes = Object.create(null);

  function confirmedQuote(result, fields) {
    if (!result || result.ok !== true || result.accepted === false || result.quarantined === true) return false;
    var leadId = String(result.lead_id || '');
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(leadId)) return false;
    if (publishedQuotes[leadId]) return true;
    var data = fields || {};
    var forms = ['request_for_quote_page', 'rfq_modal', 'rfq_product', 'press_brake_two_step'];
    var types = ['press_brake_tooling', 'laser_consumables', 'filtration', 'equipment_general'];
    var payload = {
      lead_id: leadId,
      form_id: forms.indexOf(data.form_id) >= 0 ? data.form_id : 'request_for_quote_page',
      rfq_type: types.indexOf(data.rfq_type) >= 0 ? data.rfq_type : 'equipment_general'
    };
    var attempts = 0;
    function publish() {
      attempts += 1;
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('mv:quote_submitted', payload);
          publishedQuotes[leadId] = true;
          return;
        }
      } catch (error) {}
      if (attempts < 10) window.setTimeout(publish, 500);
    }
    publishedQuotes[leadId] = true;
    publish();
    return true;
  }

  firstTouch();
  document.addEventListener('click', function (event) {
    var searchLink = event.target.closest('.mv-search-rfq__button');
    if (searchLink) {
      track('rfq_search_no_result_click', {
        search_term: new URL(searchLink.href, window.location.href).searchParams.get('q') || '',
        source_path: window.location.pathname
      });
    }

    var entryLink = event.target.closest('[data-mv-rfq-link]');
    if (!entryLink) return;
    track('rfq_entry_click', {
      entry_source: entryLink.dataset.mvRfqLink || '',
      destination_path: new URL(entryLink.href, window.location.href).pathname,
      source_path: window.location.pathname
    });
  });
  window.MVRfqAttribution = {
    context: context,
    sessionId: sessionId,
    track: track,
    confirmedQuote: confirmedQuote
  };
})(window, document);

